import styled from 'styled-components'

export const GlobalSearchResultTabsStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${(props) => props.theme.space.small};
  padding: ${(props) => props.theme.space.xsmall}
    ${(props) => props.theme.space.medium};
`
